import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M6.9 7.15h8.05l2.95 2.95v6.15A1.75 1.75 0 0 1 16.15 18H6.9a1.75 1.75 0 0 1-1.75-1.75V8.9A1.75 1.75 0 0 1 6.9 7.15Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M14.95 7.2v2.95h2.95"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.6",
      d: "M10.65 10.15c-.8 0-1.35.42-1.35 1.03 0 .69.67.96 1.4 1.17.78.23 1.56.54 1.56 1.43 0 .86-.75 1.42-1.77 1.42-.78 0-1.42-.23-1.98-.69M10.65 9.1v7.1"
    }, null, -1)
  ]))]))
}
export default { render: render }